"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const ico_close_png_1 = __importDefault(require("@/assets/img/ico-close.png"));
const success_icon_png_1 = __importDefault(require("@/assets/images/success_icon.png"));
const react_redux_1 = require("react-redux");
const login2FASelector_1 = require("../selectors/login2FASelector");
const react_intl_1 = require("react-intl");
const login2FAAction_1 = require("../actions/login2FAAction");
const types_1 = require("../types");
const styles_1 = require("@mui/styles");
const useStyles = (0, styles_1.makeStyles)(() => ({
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        outline: 0,
        width: '320px',
        height: '158px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: '"Open Sans", Helvetica,Arial,sans-serif',
        background: '#f7f7f7',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1102
    },
    IconClose: {
        position: 'absolute',
        textDecoration: 'none',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        display: 'block',
        top: '24px',
        right: '24px',
        cursor: 'pointer'
    },
    DialogContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        alignItems: 'center'
    },
    WrapIcon: {
        background: `url(${success_icon_png_1.default}) no-repeat`,
        width: 33,
        height: 33,
        backgroundSize: 'contain',
        marginTop: '32px',
        marginBottom: '20px'
    },
    content: {
        width: '220px',
        textAlign: 'center'
    }
}));
const Login2FAApproved = ({ open }) => {
    const classes = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { maskedMobileNo } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const toggleClose = () => {
        dispatch((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.VERIFY_SUCCESS_DISMISS));
    };
    return (react_1.default.createElement(material_1.Dialog, { open: open, classes: { paper: classes.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: classes.IconClose, onClick: toggleClose }),
        react_1.default.createElement("div", { className: classes.DialogContent },
            react_1.default.createElement("div", { className: classes.WrapIcon }),
            react_1.default.createElement("div", { className: classes.content },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-approved-content", values: {
                        strongNumber: react_1.default.createElement("strong", null, maskedMobileNo)
                    } })))));
};
exports.default = Login2FAApproved;
